import React, { Component } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import axios from 'axios';
class Registration extends React.Component {
    state = {
            name: '',
            dob: '',
            gender: '',
            religion: '',
            category: '',
            address: '',
            course: '',
            contact: '',
            gname: '',
            gcontact: '',
            exam_center: '',
            isDeclare: false,
            goccupation: '',
            studentSignature: null,
            studentSignaturePreview: "https://dummyimage.com/100x40/eeeeee/000000&text=STUDENT+SIGNATURE",

            studentPhoto: null,
            studentPhotoPreview: "https://dummyimage.com/120x180/eeeeee/000000&text=STUDENT+PHOTO"
        };

        componentDidMount() {
            localStorage.setItem('sID', null);
           
        }
       
   handleInputChange = (event) => {
        const { name, type, value, checked } = event.target;

        this.setState({
            [name]: type === 'checkbox' ? checked : value
        });
    };

   handleSubmit = (event) => {
        event.preventDefault();

        if (!this.state.name) {
            alert("PLEASE ENTER NAME");
            return;
        }

        if (!this.state.isDeclare) {
            alert("PLEASE ACCEPT DECLARATION");
            return;
        }

        const formData = new FormData();

        formData.append('name', this.state.name.toUpperCase());
        formData.append('dob', this.state.dob);
        formData.append('gender', this.state.gender);
        formData.append('religion', this.state.religion);
        formData.append('category', this.state.category);
        formData.append('address', this.state.address.toUpperCase());
        formData.append('course', this.state.course);
        formData.append('contact', this.state.contact);

        formData.append('gname', this.state.gname.toUpperCase());
        formData.append('goccupation', this.state.goccupation.toUpperCase()); // ✅ NEW
        formData.append('gcontact', this.state.gcontact);

        formData.append('exam_center', this.state.exam_center);

        formData.append('student_photo', this.state.studentPhoto);
        formData.append('student_signature', this.state.studentSignature); // ✅ NEW

        axios.post('https://dirasa.in/api/registration.php', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(res => {
            if (res.data.status === 'success') {
                localStorage.setItem('sID', res.data.formId);
                window.location = '/PrintForm';
            } else {
                alert(res.data.message);
            }
        })
        .catch(() => alert("SERVER ERROR"));
    };

     handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            this.setState({
                studentPhoto: file,
                studentPhotoPreview: URL.createObjectURL(file)
            });
        }
    };
    render() {
        return (
            <div style={{marginTop:"200px",marginBottom:"100px"}} >
                <Container>
                    <Row>
                        <Col>
                           <div className="text-center">
                               <img src="img/header.jpeg" style={{    width:"320px"}}></img>
                            </div>
                           
                            <div className="text-center" style={{    marginTop: "16px", marginBottom:"50px"}}><span style={{backgroundColor: "red",padding: "7px",borderRadius: "10px",color: "#fff",fontWeight: "700"}}>APPLICATION FORM</span></div>
                            
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Group >
                                    <Form.Label className="level" >NAME</Form.Label>
                                    <Form.Control type="text" name="name" id="name" className="input-text"  placeholder="Enter Full Name" onChange={this.handleInputChange} required/>
                                    <Form.Text className="text-muted">
                                    Enter your full name.
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group >
                                    <Form.Label className="level" >DATE OF BIRTH</Form.Label>
                                    <Form.Control type="date" name="dob"   placeholder="" onChange={this.handleInputChange}  required/>
                                    <Form.Text className="text-muted">
                                    Select DOB.
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group>
                                <Form.Label className="level">GENDER</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="gender"
                                        id="gender"
                                        className="input-text"
                                        onChange={this.handleInputChange}
                                        required
                                    >
                                        <option value="">SELECT GENDER</option>
                                        <option value="MALE">MALE</option>
                                        <option value="FEMALE">FEMALE</option>
                                        <option value="OTHER">OTHER</option>
                                    </Form.Control>
                                    <Form.Text className="text-muted">
                                        Select Gender.
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group>
                                <Form.Label className="level">RELIGION</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="religion"
                                            id="religion"
                                            className="input-text"
                                            onChange={this.handleInputChange}
                                            required
                                        >
                                            <option value="">SELECT RELIGION</option>
                                            <option value="HINDU">HINDU</option>
                                            <option value="MUSLIM">MUSLIM</option>
                                            <option value="CHRISTIAN">CHRISTIAN</option>
                                            <option value="SIKH">SIKH</option>
                                            <option value="OTHER">OTHER</option>
                                        </Form.Control>
                                        <Form.Text className="text-muted">
                                             SELECT RELIGION.
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group>
                                    <Form.Label className="level">CATEGORY</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="category"
                                            id="category"
                                            className="input-text"
                                            onChange={this.handleInputChange}
                                            required
                                        >
                                            <option value="">SELECT CATEGORY</option>
                                            <option value="SC">SC</option>
                                            <option value="ST">ST</option>
                                            <option value="OBC">OBC</option>
                                            <option value="GENERAL">GENERAL</option>
                                        </Form.Control>
                                        <Form.Text className="text-muted">
                                            Select Category.
                                        </Form.Text>
                                    </Form.Group>



                                <Form.Group >
                                    <Form.Label className="level" >GUARDIAN'S NAME</Form.Label>
                                    <Form.Control type="text" name="gname" id="gname" className="input-text"  placeholder="Enter Guardian's Name" onChange={this.handleInputChange} required/>
                                    <Form.Text className="text-muted">
                                    Enter Guardian's Name.
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group>
                                <Form.Label className="level">GUARDIAN OCCUPATION</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="goccupation"
                                    placeholder="GUARDIAN OCCUPATION"
                                    value={this.state.goccupation}
                                    onChange={(e) => {
                                        this.setState({
                                            goccupation: e.target.value.toUpperCase()
                                        });
                                    }}
                                    required
                                />
                            </Form.Group>


                                <Form.Group >
                                    <Form.Label className="level">ADDRESS</Form.Label>
                                    <Form.Control type="text" placeholder="Address" className="input-text" name="address" onChange={this.handleInputChange}  required/>
                                    <Form.Text className="text-muted">
                                    Enter Present Address.
                                    </Form.Text>
                                </Form.Group>
                                
                                <Form.Group >
                                    <Form.Label className="level">COURSE</Form.Label>
                                    <Form.Control
                                        as="select"
                                        className="my-1 mr-sm-2"
                                        id=""
                                        name="course"
                                        required
                                        onChange={this.handleInputChange}
                                        custom 
                                    >
                                        <option value="">Choose...</option>
                                        <option value="SCIENCE BOARD(XI-XII)" >SCIENCE BOARD(XI-XII)</option>
                                        <option value="SCIENCE BOARD + NEET(XI-XII)" >SCIENCE BOARD + NEET(XI-XII)</option>
                                        <option value="SCIENCE BOARD + JEE(XI-XII)" >SCIENCE BOARD + JEE(XI-XII)</option>
                                        <option value="SCIENCE BOARD + IPM(XI-XII)" >SCIENCE BOARD + IPM(XI-XII)</option>
                                        <option value="NEET 1 YEAR PROGRAM(H.S PASSED)" >NEET 1 YEAR PROGRAM(H.S PASSED)</option>
                                        <option value="NEET DROPPER 1 YEAR PROGRAM(H.S PASSED)" >NEET DROPPER 1 YEAR PROGRAM(H.S PASSED)</option>
                                        <option value="CRASH COURSE (NEET)" >CRASH COURSE (NEET)</option>
                                        <option value="TEST SERIES PROGRAM">TEST SERIES PROGRAM</option>
                                        
                                    </Form.Control>
                                    <Form.Text className="text-muted">
                                         Choose Courses.
                                    </Form.Text>
                                </Form.Group>
                               
                                <Form.Group >
                                    <Form.Label className="level">MOBILE NO.</Form.Label>
                                    <Form.Control type="number"  placeholder="Mobile No." name="contact" onChange={this.handleInputChange} required/>
                                    <Form.Text className="text-muted">
                                    Enter Mobile No.
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group >
                                    <Form.Label className="level">GUARDIAN MOBILE NO.</Form.Label>
                                    <Form.Control type="number"  placeholder="Guardian's Mobile No." name="gcontact" onChange={this.handleInputChange} required/>
                                    <Form.Text className="text-muted">
                                    Enter Guardian's Mobile No.
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label className="level">EXAM CENTER</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="exam_center"
                                        className="input-text"
                                        onChange={this.handleInputChange}
                                        required
                                    >
                                        <option value="">SELECT EXAM CENTER</option>

                                        <option value="Itahar High School (H.S), Itahar, Uttar Dinajpur (Date: 15/02/26, Time: 12 PM)">
                                            <bold>Itahar High School (H.S)</bold>, Itahar, Uttar Dinajpur
                                            (Date: 15/02/26, Time: 12 PM)
                                        </option>

                                        <option value="Rashakhowa High School (H.S), Rashakhowa, Uttar Dinajpur (Date: 16/02/26, Time: 1 PM)">
                                            <strong>Rashakhowa High School (H.S)</strong>, Rashakhowa, Uttar Dinajpur
                                            (Date: 16/02/26, Time: 1 PM)
                                        </option>

                                        <option value="Kumarganj High School (H.S), Kumarganj, Malda (Date: 17/02/26, Time: 1 PM)">
                                            <strong>Kumarganj High School (H.S)</strong>, Kumarganj, Malda
                                            (Date: 17/02/26, Time: 1 PM)
                                        </option>

                                        <option value="OSD English School, Samsi Bypass, Malda (Date: 21/02/26, Time: 1 PM)">
                                            <strong>OSD English School</strong>, Samsi Bypass, Malda
                                            (Date: 21/02/26, Time: 1 PM)
                                        </option>

                                        <option value="Narayanpur High School (H.S), Narayanpur, Dakshin Dinajpur (Date: 22/02/26, Time: 1 PM)">
                                            <strong>Narayanpur High School (H.S)</strong>, Narayanpur, Dakshin Dinajpur
                                            (Date: 22/02/26, Time: 1 PM)
                                        </option>

                                        <option value="Dirasa Boys Unit, Gabgachi Jadavpur, Malda (Date: 24/02/26, Time: 1 PM)">
                                            <strong>Dirasa Boys Unit</strong>, Gabgachi Jadavpur, Malda
                                            (Date: 24/02/26, Time: 1 PM)
                                        </option>

                                    </Form.Control>

                                    <Form.Text className="text-muted">
                                        SELECT YOUR PREFERRED EXAM CENTER.
                                    </Form.Text>
                                </Form.Group>

                                 {/* IMAGE UPLOAD */}
                               
                                    <Form.Group>
                                    <Form.Label>STUDENT PHOTO</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={this.handleImageChange}
                                        required
                                    />
                                </Form.Group>

                                {this.state.studentPhotoPreview && (
                                    <div className="text-center">
                                        <img
                                                src={this.state.studentPhotoPreview || "https://dummyimage.com/120x180/eeeeee/000000&text=STUDENT+PHOTO"}
                                                alt="Preview"
                                                style={{
                                                    width: "150px",
                                                    height: "200px",
                                                    objectFit: "cover",
                                                    border: "1px solid #ccc",
                                                    marginTop: "20px"
                                                }}
                                            />

                                        
                                    </div>
                                )}

                              <Form.Group>
                                        <Form.Label>STUDENT SIGNATURE</Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    this.setState({
                                                        studentSignature: file,
                                                        studentSignaturePreview: URL.createObjectURL(file)
                                                    });
                                                }
                                            }}
                                            required
                                        />
                                    </Form.Group>

                                    {this.state.studentSignaturePreview && (
                                        <div className="text-center mt-2">
                                            <img
                                                src={this.state.studentSignaturePreview || "https://dummyimage.com/100x40/eeeeee/000000&text=STUDENT+SIGNATURE"}
                                                alt="Signature Preview"
                                                style={{
                                                    width: "200px",
                                                    height: "80px",
                                                    objectFit: "contain",
                                                    border: "1px solid #ccc"
                                                }}
                                            />
                                        </div>
                                    )}

                                <Form.Group className="mt-4">
                                    <Form.Check type="checkbox" name="isDeclare" label="I here by declare that all the information provided is correct." onChange={this.handleInputChange} required />
                                </Form.Group>
                                    
                                <Row className="mt-4">
                                    <Col
                                        xs={12}
                                        className="d-flex justify-content-center justify-content-md-end"
                                    >
                                        <Button
                                            variant="secondary"
                                            size="lg"
                                            onClick={() => window.location.href = '/'}
                                            style={{
                                                minWidth: "170px",
                                                marginRight: "15px",
                                                padding: "12px 24px",
                                                fontWeight: "600"
                                            }}
                                        >
                                            CANCEL
                                        </Button>

                                        <Button
                                            variant="danger"
                                            type="submit"
                                            size="lg"
                                            style={{
                                                minWidth: "170px",
                                                padding: "12px 24px",
                                                fontWeight: "600"
                                            }}
                                        >
                                            SUBMIT
                                        </Button>
                                    </Col>
                                </Row>

                                        
                                    
                                
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Registration;